export default class ClassConstants {
    public static CANVAS_CLASS_NAME = "webgl";
    public static LOADING_CLASS_NAME = "page_overlay_loading";
    public static LOADING_CONTINUE_BUTTON_CLASS_NAME =
        "page_overlay_loading_continue";
    public static LOADING_TEXT_CLASS_NAME = "page_overlay_loading_text";
    public static DIALOG_CLASS_NAME = "dialog";
    public static DIALOG_CONTENT_CLASS_NAME = "dialog__content";
    public static DIALOG_NEXT_BUTTON_CLASS_NAME = "dialog__button--next";
    public static DIALOG_SKIP_BUTTON_CLASS_NAME = "dialog__button--skip";

    public static MENU_CLASS_NAME = "menu";
    public static MENU_ANIMATED_CLASS_NAME = "menu--animated";
    public static MENU_NAVIGATION_CLASS_NAME = "menu__navigation";
    public static MENU_BUTTON_MAP_CLASS_NAME = "menu__map";
    public static MENU_BUTTON_INTERNSHIP_CLASS_NAME = "menu__internship";
    public static MENU_BUTTON_PROJECTS_CLASS_NAME = "menu__projects";
    public static MENU_BUTTON_ABOUT_ME_CLASS_NAME = "menu__about_me";

    public static BOOK_CONTROLS_CLASS_NAME = "book_controls";
    public static BOOK_CONTROLS_CLOSE_BUTTON_CLASS_NAME = "button__close";
    public static BOOK_CONTROLS_LEFT_BUTTON_CLASS_NAME = "button__left";
    public static BOOK_CONTROLS_RIGHT_BUTTON_CLASS_NAME = "button__right";

    public static MOBILE_CONTROLS_CLASS_NAME = "mobile_controls";
    public static MOBILE_CONTROLS_LEFT_CLASS_NAME = "mobile_controls--left";
    public static MOBILE_CONTROLS_RIGHT_CLASS_NAME = "mobile_controls--right";
    public static MOBILE_CONTROLS_BUTTON_FORWARDS_CLASS_NAME =
        "mobile_controls__button--forwards";
    public static MOBILE_CONTROLS_BUTTON_BACKWARDS_CLASS_NAME =
        "mobile_controls__button--backwards";
    public static MOBILE_CONTROLS_BUTTON_LEFT_CLASS_NAME =
        "mobile_controls__button--left";
    public static MOBILE_CONTROLS_BUTTON_RIGHT_CLASS_NAME =
        "mobile_controls__button--right";
    public static MOBILE_CONTROLS_BUTTON_INTERACT_CLASS_NAME =
        "mobile_controls__button--interact";

    public static LINK_CONTAINER = "link_container";
    public static LINK_CONTAINER_LEFT = "link_container--left";
    public static LINK_CONTAINER_CENTER = "link_container--center";
    public static LINK_CONTAINER_RIGHT = "link_container--right";

    public static POINTER_CLASS_NAME = "pointer";

    public static HIDDEN = "hidden";
    public static FADE_IN = "fade_in";
    public static FADE_OUT = "fade_out";
}
